import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { MyTimesheetFilterBody } from "my-timesheet/components";
import {
  useMyTimesheetCostList,
  useMyTimesheetFilterCounterState,
  useMyTimesheetFilterOpenState,
  useMyTimesheetFilterProperties,
} from "my-timesheet/hooks";
import {
  OcFilterItemAvailableList,
  OcFilterItemSearchForm,
  OcFilterItemSelectedList,
} from "oc/components";

interface MyTimesheetCostsFilterProps {
  isMobile: boolean;
}

// TODO f not used anymore
export const MyTimesheetCostsFilter: React.FC<MyTimesheetCostsFilterProps> = ({
  isMobile,
}) => {
  const { state: openedFilter } = useMyTimesheetFilterOpenState();
  const { state: counter, setState: updateCounter } =
    useMyTimesheetFilterCounterState();

  const [filterProperties, setFilterProperties] = useState({
    page: 1,
    pageSize: 25,
    sort: "name",
    sortDirection: "asc",
    search: "",
  });

  const { data } = useMyTimesheetCostList({
    page: filterProperties.page,
    pageSize: filterProperties.pageSize,
    sort: filterProperties.sort,
    sortDirection: filterProperties.sortDirection,
    searchText: filterProperties.search,
    searchField: "name",
  });

  const {
    availableItems,
    selectedItems,
    handleSearch,
    handleClearSearch,
    handleAddItem,
    handleRemoveItem,
  } = useMyTimesheetFilterProperties({
    filterProperties,
    data,
    setFilterProperties,
    type: "cost",
  });

  useEffect(() => {
    const length = selectedItems?.length || 0;
    if (counter["cost"] !== length) {
      updateCounter({ ...counter, cost: length });
    }
  }, [counter, selectedItems, updateCounter]);

  return (
    <MyTimesheetFilterBody
      open={openedFilter["cost"]}
      type="cost"
      width={isMobile ? "100%" : "340px"}
    >
      <Box width={isMobile ? "auto" : "340px"}>
        <OcFilterItemSearchForm
          search={filterProperties.search}
          onSearch={handleSearch}
          onClearSearch={handleClearSearch}
          disabled={false}
        />
        <OcFilterItemAvailableList
          selectedItems={selectedItems}
          availableItems={availableItems}
          addItem={handleAddItem}
          filterType={"cost"}
          onFetchMore={() => {}}
        />
        <OcFilterItemSelectedList
          selectedItems={selectedItems}
          filterType={"cost"}
          removeItem={handleRemoveItem}
        />
        <Box height="16px" />
      </Box>
    </MyTimesheetFilterBody>
  );
};

export default MyTimesheetCostsFilter;
